import { Globe } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from 'components/ui/Button';
import { cn } from 'utils/classnames';

interface LanguageToggleProps {
  className?: string;
}

export const LanguageToggle = ({ className }: LanguageToggleProps = {}) => {
  const { t, i18n } = useTranslation();

  const toggleLanguage = () => {
    i18n.changeLanguage(i18n.language === 'en' ? 'es' : 'en');
  };

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      className={cn('h-10 shrink-0 rounded-xl px-3 gap-1.5', className)}
      onClick={toggleLanguage}
      aria-label={t('header.toggleLanguage')}
    >
      <Globe className="h-4 w-4" />
      <span className="text-xs font-semibold">{i18n.language.toUpperCase()}</span>
    </Button>
  );
};
